<template>
  <span>{{ brand }}</span>
</template>
<script src="./brand-name.js"></script>
